import React, { useEffect, useState } from 'react'
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Card } from '@mui/material'
import { ArrowCircleRightOutlined } from '@mui/icons-material';

const Index = () => {
    const params = useParams()
    const Navigate = useNavigate()
    const [allData, setAllData] = useState({})
    const getDetailById = async () => {
        try {
            const res = await service.offer.getDetailById(params.id);
            console.log("resresresres", res)
            if (res?.data?.data) {
                setAllData(res?.data?.data)
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
        }
    };

    useEffect(() => {
        if (params?.id) {
            getDetailById();
        }
    }, []);
    function getAllBusinessNames(businessLocations) {
        if (!businessLocations) return '';

        return businessLocations
            .map(loc => loc?.businessId?.businessName)
            .filter(Boolean)
            .join(', ');
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card className='glassmorphism-card' sx={{ padding: 3, boxShadow: 2 }}>

                <SoftBox
                >
                    <SoftBox sx={{ display: 'flex', gap: 2 }}>
                        <SoftBox
                            variant="outlined"
                            color="info"
                            style={{ cursor: "pointer" }}
                            onClick={() => Navigate(-1)}
                        >
                            <ArrowCircleRightOutlined
                                style={{ transform: "rotate(180deg)", color: "#141414" }}
                            />
                        </SoftBox>
                        <SoftTypography variant="h6" fontWeight="bold" mb={3}>
                            Offer Details
                        </SoftTypography>
                    </SoftBox>


                    {[
                        { label: "Name", value: allData?.name },
                        { label: "Status", value: allData?.status },
                        { label: "Type", value: allData?.type },
                        // { label: "Percentage", value: allData?.percentage },
                        { label: "Usage Count", value: allData?.usageCount },
                        { label: "Category", value: allData?.category?.name },
                        { label: "Sub Category", value: allData?.subCategory?.name },
                        {
                            label: "Businesses", value: getAllBusinessNames(allData?.businesses) || ''
                        },
                        {
                            label: "Start Date",
                            value: allData?.startDate
                                ? moment(allData.startDate).format('MM-DD-YYYY, hh:mm A')
                                : '-'
                        },
                        {
                            label: "End Date",
                            value: allData?.endDate
                                ? moment(allData.endDate).format('MM-DD-YYYY, hh:mm A')
                                : '-'
                        }
                    ].map((item, i) => (
                        <SoftBox
                            display={'flex'} mb={3} key={i} gap={2}
                        >
                            <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">{item.label}</SoftTypography>
                            <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">:</SoftTypography>
                            <SoftTypography variant="button" fontWeight="regular" color="text">{item.value}</SoftTypography>
                        </SoftBox>
                    ))}
                </SoftBox>

            </Card>
        </DashboardLayout>
    )
}

export default Index